import routes from '@config/routes';
import { mutate } from 'swr';

export function invalidatePropertySearch() {
  setTimeout(() => {
    mutate(routes.propertySearch);
  }, 500);
}
